<template>
	<div id="ap">
		<a-layout>
			<div class="content-header">
				<a-affix :offset-top="0" style="width: 100%">
					<a-row type="flex" justify="space-between">
						<a-col span="12">
							<a-page-header :title="activityTitle || '秒杀订单'" @back="$router.back()"></a-page-header>
						</a-col>
						<a-col span="12">
							<a-row type="flex" align="middle" justify="end" :gutter="10">
								<a-col span="4">
									<a-select v-model="param.activityId" allowClear placeholder="选择活动" style="width: 160px" @change="getList" showSearch :filterOption="filterActivityOption">
										<a-select-option v-for="act in activityList" :key="act.activityId" :value="act.activityId">{{ act.title }}</a-select-option>
									</a-select>
								</a-col>
								<a-col span="4">
									<a-input v-model="param.orderSn" allowClear search @pressEnter="getList" @on-clear="getList" placeholder="订单号"></a-input>
								</a-col>
								<a-col span="4">
									<a-input v-model="param.phone" allowClear search @pressEnter="getList" @on-clear="getList" placeholder="手机号"></a-input>
								</a-col>
								<a-col span="4">
									<a-select v-model="param.status" allowClear placeholder="订单状态" style="width: 100px" @change="getList">
										<a-select-option :value="-1">已取消</a-select-option>
										<a-select-option :value="0">待支付</a-select-option>
										<a-select-option :value="1">待核销</a-select-option>
										<a-select-option :value="2">已完成</a-select-option>
									</a-select>
								</a-col>
								<a-col span="3">
									<a-button type="primary" icon="download" @click="doExport">导出</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</a-affix>
			</div>
		</a-layout>

		<a-layout>
			<a-layout-content>
				<a-table :scroll="{ x: '100%' }" :pagination="false" :style="{ background: '#FFF' }" size="small" row-key="orderId" border :columns="keys" ref="list" :loading="loading" :data-source="data.records">
					<template slot-scope="row" slot="orderSn">
						{{ row.orderSn }}
					</template>
					<template slot-scope="row" slot="goods">
						<a-space size="small">
							<a-image v-if="row.goodsThumb" :width="40" :height="40" :src="row.goodsThumb" />
							<span>{{ row.goodsName }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="storeName">
						{{ row.storeName }}
					</template>
					<template slot-scope="row" slot="price">
						<a-space direction="vertical" size="small">
							<span>数量：{{ row.number }}</span>
							<span style="color: #f5222d; font-weight: bold">￥{{ row.totalPrice }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="user">
						<a-space direction="vertical" size="small">
							<span>{{ row.name }}</span>
							<span>{{ row.phone }}</span>
						</a-space>
					</template>
					<template slot-scope="row" slot="status">
						<a-tag v-if="row.status == '已完成'" color="green">已完成</a-tag>
						<a-tag v-else-if="row.status == '待核销'" color="blue">待核销</a-tag>
						<a-tag v-else-if="row.status == '待支付'" color="orange">待支付</a-tag>
						<a-tag v-else color="default">已取消</a-tag>
					</template>
					<template slot-scope="row" slot="createTime">
						{{ row.createTime }}
					</template>
				</a-table>
			</a-layout-content>
		</a-layout>
		<a-row>
			<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
				<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
			</a-col>
		</a-row>
	</div>
</template>

<script>
import ExporttoExcel from '@/common/ExportExcel.js';
export default {
	data() {
		return {
			loading: false,
			activityTitle: '',
			activityList: [],
			data: { records: [] },
			param: {
				page: 1,
				limit: 20,
				activityId: '',
				orderSn: '',
				phone: '',
				status: ''
			},
			keys: [
				{ title: '订单号', scopedSlots: { customRender: 'orderSn' }, width: 180 },
				{ title: '商品', scopedSlots: { customRender: 'goods' }, width: 250 },
				{ title: '商家', scopedSlots: { customRender: 'storeName' }, width: 150 },
				{ title: '数量/金额', scopedSlots: { customRender: 'price' }, width: 120, align: 'center' },
				{ title: '收货人', scopedSlots: { customRender: 'user' }, width: 150 },
				{ title: '状态', scopedSlots: { customRender: 'status' }, width: 100, align: 'center' },
				{ title: '下单时间', scopedSlots: { customRender: 'createTime' }, width: 170, align: 'center' }
			]
		};
	},
	created() {
		this.activityTitle = this.$route.query.title;
		this.param.activityId = this.$route.query.activityId ? parseInt(this.$route.query.activityId) : '';
		this.loadActivityList();
		this.doRefresh();
	},
	methods: {
		loadActivityList() {
			this.http.get('/platform/activity/list', { page: 1, limit: 100 }).then(ret => {
				if (ret.code == 200) {
					this.activityList = ret.data.records || [];
				}
			});
		},
		filterActivityOption(input, option) {
			return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
		},
		doExport() {
			this.http.get('/platform/activity/order/list', { ...this.param, limit: 99999 }).then(ret => {
				if (ret.code == 200) {
					const columns = [
						{ title: '订单号', dataIndex: 'orderSn' },
						{ title: '商品名称', dataIndex: 'goodsName' },
						{ title: '商家名称', dataIndex: 'storeName' },
						{ title: '购买数量', dataIndex: 'number' },
						{ title: '订单金额', dataIndex: 'totalPrice' },
						{ title: '收货人', dataIndex: 'name' },
						{ title: '联系电话', dataIndex: 'phone' },
						{ title: '收货地址', dataIndex: 'address' },
						{ title: '支付状态', dataIndex: 'payStatus' },
						{ title: '核销状态', dataIndex: 'verifyStatus' },
						{ title: '订单状态', dataIndex: 'status' },
						{ title: '下单时间', dataIndex: 'createTime' }
					];
					ExporttoExcel(columns, ret.data.records, '秒杀订单');
				}
			});
		},
		getList() {
			this.loading = true;
			this.http
				.get('/platform/activity/order/list', this.param)
				.then(ret => {
					this.data = ret.data;
				})
				.finally(() => {
					this.loading = false;
				});
		},
		getNext(page, pageSize) {
			this.param.page = page;
			this.param.limit = pageSize;
			this.getList();
		},
		setLimit(current, size) {
			this.param.limit = size;
			this.param.page = 1;
			this.getList();
		},
		doRefresh() {
			this.param.page = 1;
			this.getList();
		}
	}
};
</script>

<style scoped>
#ap {
	padding: 15px;
}
</style>
